import React from 'react';
import { HomeIcon, SearchIcon, KeyIcon, BarChartIcon } from 'lucide-react';
export const ServicesSection = () => {
  const services = [{
    icon: <SearchIcon className="h-8 w-8 text-[#00A3E0]" data-id="element-823" />,
    title: 'Property Search',
    description: 'Access our exclusive database of luxury properties, including off-market listings not available to the general public.'
  }, {
    icon: <HomeIcon className="h-8 w-8 text-[#00A3E0]" data-id="element-824" />,
    title: 'Property Management',
    description: 'Comprehensive management services for property owners, ensuring your investment is well-maintained and profitable.'
  }, {
    icon: <KeyIcon className="h-8 w-8 text-[#00A3E0]" data-id="element-825" />,
    title: 'Buying & Selling',
    description: 'Expert guidance through every step of the buying or selling process, with personalized strategies for each client.'
  }, {
    icon: <BarChartIcon className="h-8 w-8 text-[#00A3E0]" data-id="element-826" />,
    title: 'Investment Advisory',
    description: "Strategic advice on real estate investments, market trends, and opportunities to maximize your portfolio's value."
  }];
  return <section className="py-20 bg-[#f2f2ed] w-full" data-id="element-827">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-828">
        <div className="mb-16" data-id="element-829">
          <h6 className="text-sm uppercase tracking-wider text-[#3a4a56] font-medium mb-6" data-id="element-830">
            Services
          </h6>
          <h2 className="text-4xl md:text-5xl font-normal text-[#3a4a56] leading-tight mb-10" data-id="element-831">
            Comprehensive real estate services tailored to your luxury lifestyle
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-832">
          {services.map((service, index) => <div key={index} className="p-8 border-b border-[#3a4a56]" data-id="element-833">
              <div className="flex justify-start mb-6" data-id="element-834">{service.icon}</div>
              <h3 className="text-xl font-normal text-[#3a4a56] mb-4" data-id="element-835">
                {service.title}
              </h3>
              <p className="text-[#3a4a56]" data-id="element-836">{service.description}</p>
            </div>)}
        </div>
        <div className="mt-16 text-center" data-id="element-837">
          <button className="bg-[#3a4a56] hover:bg-[#2a3a46] text-white font-medium py-3 px-8 transition duration-200" data-id="element-838">
            Explore All Services
          </button>
        </div>
      </div>
    </section>;
};